import { signal } from '@preact/signals-react'

export const profileSchemaSignal = signal({})
export const profileSchemaErrorSignal = signal(null)
export const profileSchemaLoadedSignal = signal(false)
export const profileSchemaVersionSignal = signal(null)